import { PureComponent, ReactNode } from "react";
import { Form, Modal } from "react-bootstrap";
import SupportDepartementModalStates, { SupportDepartementModalProps } from "./SupportDepartementModal.models";

export default class SupportDepartementModal extends PureComponent<SupportDepartementModalProps, SupportDepartementModalStates> {

    constructor(props: any) {
        super(props);
        this.state = { title: "" };
    }

    render(): ReactNode {
        let { onHandleClose, showModal, onHandleRequest, staff } = this.props;
        let { title } = this.state;
        return <>
            <Modal show={showModal} onHide={onHandleClose} animation={true}>
                <Modal.Body >
                    <Form dir="rtl">
                        <Form.Group>
                            <Form.Label>
                                عنوان
                            </Form.Label>
                            <Form.Control type="text" value={title} onChange={(e) => this.setState({ title: e.target.value })}>
                            </Form.Control>
                        </Form.Group>
                    </Form>
                </Modal.Body >

                <Modal.Footer dir="ltr">
                    <button className="btn btn btn-success tk-float-right" onClick={() => onHandleRequest(title, staff)}>درخواست ارتباط</button>
                    <button className="btn btn btn-primary tk-float-left" onClick={onHandleClose}>بستن</button>
                </Modal.Footer>
            </Modal >
        </>;
    }
}